import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  MenuItem,
  Modal,
  InputLabel,
  FormControl,
  Grid,
  Select,
  TextField,
  FormControlLabel,
  Checkbox,
  Table,
  TableHead,
  TableBody,
  Button,
  TableContainer,
  TableCell,
  TableRow,
  Paper,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Add, Delete, Undo, Redo } from "@mui/icons-material";
import { useParams, useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import base64 from "base64-js";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const EditClass = () => {
  const [canDelete, setCanDelete] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [selectedValue, setSelectedValue] = useState("lightOptionValue");
  const [className, setClassName] = useState("");
  const [sequenceNo, setSequenceNo] = useState("");
  const [classType, setClassType] = useState([]);
  const [teacherData, setTeacherData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [sectionNameValue, setSectionNameValue] = useState("");
  const [seatCapacityValue, setSeatCapacityValue] = useState("");
  const [inchargeValue, setInchargeValue] = useState("");
  const [sectionDetails, setSectionDetails] = useState([]);
  const [chargeDetails, setChargeDetails] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [noOf_BrackLeacture, setNoOf_BrackLeacture] = useState("");
  const [noOfBrack, setNoOfBrack] = useState("");
  const [resultType, setResultType] = useState("");
  const [maxLecture, setMaxLectureAllowed] = useState("");
  const [noBreakCheckbox, setNoBreakCheckbox] = useState(false);
  const [breakAfterLectureNo, setBreakAfterLectureNo] = useState("");
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [minAge, setMinAge] = useState("");
  const [maxAge, setMaxAge] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);

  // Undo/Redo state for sectionDetails
  const [sectionHistory, setSectionHistory] = useState([[]]);
  const [sectionHistoryIndex, setSectionHistoryIndex] = useState(0);

  // Delete confirmation state
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [pendingDeleteIndex, setPendingDeleteIndex] = useState(null);

  
  const navigate = useNavigate();

  const { classId, encodedFormId } = useParams();

  const decodeFormId = (encodedFormId) => {
  if (!encodedFormId || typeof encodedFormId !== "string") {
    console.error("encodedFormId is missing or invalid:", encodedFormId);
    return null;
  }
  try {
    const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
    const bytes = base64.toByteArray(paddedEncodedFormId);
    return new TextDecoder().decode(bytes);
  } catch (error) {
    console.error("Error decoding formId:", error);
    return null;
  }
};


const formId = decodeFormId(encodedFormId);

const Authorizer = async () => {
  try {
    const apiUrl = process.env.REACT_APP_BASE_URL;
    const token = sessionStorage.getItem("token");
    const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: token },
      body: JSON.stringify({ formId }),
    });
    const result = await response.json();
    const data = result[0];
    setCanDelete(data?.uDelete === 1);
  } catch (error) {
    console.error("Authorization check failed:", error);
  }
};

  // Helper: push new sectionDetails into history
  const pushSectionHistory = (newSections) => {
    const newHistory = sectionHistory.slice(0, sectionHistoryIndex + 1);
    newHistory.push(newSections);
    setSectionHistory(newHistory);
    setSectionHistoryIndex(newHistory.length - 1);
    setSectionDetails(newSections);
  };

  const handleUndo = () => {
    if (sectionHistoryIndex > 0) {
      const newIndex = sectionHistoryIndex - 1;
      setSectionHistoryIndex(newIndex);
      setSectionDetails(sectionHistory[newIndex]);
    }
  };

  const handleRedo = () => {
    if (sectionHistoryIndex < sectionHistory.length - 1) {
      const newIndex = sectionHistoryIndex + 1;
      setSectionHistoryIndex(newIndex);
      setSectionDetails(sectionHistory[newIndex]);
    }
  };

  useEffect(() => {
    const fetchClassDetails = async () => {
      try {
        const apiUrl = process.env.REACT_APP_BASE_URL;
        const token = sessionStorage.getItem("token");
        const response = await fetch(
          `${apiUrl}/CreateClass/FillClassDetails?Id=${classId}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json", Authorization: token },
            body: JSON.stringify({}),
          }
        );
        if (!response.ok) throw new Error(`Error fetching class details: ${response.status}`);
        const data = await response.json();
        const selectedClass = data.find((item) => item.classId === parseInt(classId));
        if (selectedClass) {
          setSelectedValue(selectedClass.classTypeId);
          setClassName(selectedClass.className);
          setSequenceNo(selectedClass.classSequence);
          setMaxLectureAllowed(selectedClass.maxLecture);
          setBreakAfterLectureNo(selectedClass.breakLecture);
          setResultType(selectedClass.resultTypeId.toString());
          setMinAge(selectedClass.classMinAge);
          setMaxAge(selectedClass.classMaxAge);
          setNoBreakCheckbox(selectedClass.breakNumber > 0);
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchClassDetails();
  }, [classId]);

  const handleToggleAll = (event) => {
    const checked = event.target.checked;
    const updatedChargeDetails = chargeDetails.map((item) => ({
      ...item,
      checked,
      chargeAmount: item.chargeAmount || 0,
    }));
    setChargeDetails(updatedChargeDetails);
    setSelectAllChecked(checked);
  };

  const fetchClassType = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlClassType`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({}),
      });
      if (!response.ok) throw new Error(`Error fetching class: ${response.status}`);
      const data = await response.json();
      setClassType(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchTeacher = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlTeacher`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({}),
      });
      if (!response.ok) throw new Error(`Error fetching class: ${response.status}`);
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") return;
      setTeacherData(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchSection = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlSection`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({}),
      });
      if (!response.ok) throw new Error(`Error fetching religion data: ${response.status}`);
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") return;
      setSectionData(data);
    } catch (error) {
      console.error("API request error:", error);
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const fetchddlcharge = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/CreateClass/ddlChargeDetails`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify({}),
      });
      if (!response.ok) throw new Error(`Error fetching class: ${response.status}`);
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") return;
      setChargeDetails(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchClassSectionDetails = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/CreateClass/FillClassSectionDetails?Id=${classId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: token },
        }
      );
      if (!response.ok) throw new Error(`Error fetching section details: ${response.status}`);
      const data = await response.json();
      if (data.data === null && data.msg === "Record Not Found") return;
      setSectionDetails(data);
      setSectionHistory([data]);
      setSectionHistoryIndex(0);
    } catch (error) {
      console.error("API request error:", error);
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const fetchClassChargeDetails = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        `${apiUrl}/CreateClass/FillClassChargeDetails?Id=${classId}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: token },
        }
      );
      if (!response.ok) throw new Error(`Error fetching charge details: ${response.status}`);
      const data = await response.json();
      const uniqueChargeDetails = data.filter(
        (charge, index, self) =>
          index === self.findIndex((c) => c.chargeId === charge.chargeId)
      );
      const updatedChargeDetails = uniqueChargeDetails.map((charge) => ({
        ...charge,
        checked: (charge.chargeAmount || 0) > 0,
        chargeAmount: parseFloat(charge.chargeAmount || 0).toFixed(1),
      }));
      setChargeDetails(updatedChargeDetails);
    } catch (error) {
      console.error("API request error:", error);
      setSnackbarMessage("An error occurred. Please try again later.");
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };

  const handleChargeAmountChange = (event, chargeId) => {
    let value = parseFloat(event.target.value);
    if (isNaN(value)) value = 0;
    value = Math.max(0, Math.min(value, 10000));
    const updatedChargeDetails = chargeDetails.map((charge) =>
      charge.chargeId === chargeId
        ? { ...charge, chargeAmount: value, checked: value > 0 }
        : charge
    );
    setChargeDetails(updatedChargeDetails);
    const allChecked = updatedChargeDetails.every((item) => item.checked);
    setSelectAllChecked(allChecked);
  };

  const handleIndividualCheckboxChange = (chargeId) => {
    const updatedChargeDetails = chargeDetails.map((charge) =>
      charge.chargeId === chargeId ? { ...charge, checked: !charge.checked } : charge
    );
    setChargeDetails(updatedChargeDetails);
    const allChecked = updatedChargeDetails.every((item) => item.checked);
    setSelectAllChecked(allChecked);
  };

  const handleAddSectionDetails = () => {
    const selectedSection = sectionData.find(
      (section) => section.sectionId === sectionNameValue
    );
    const newSection = {
      sectionId: sectionNameValue,
      sectionName: selectedSection ? selectedSection.sectionName : "",
      seatCapacity: seatCapacityValue,
      incharge:
        teacherData.find((teacher) => teacher.employeeId === inchargeValue)?.employeeName || "",
      inchargeId: inchargeValue,
    };
    const newSections = [...sectionDetails, newSection];
    pushSectionHistory(newSections);
    setSectionNameValue("");
    setSeatCapacityValue("");
    setInchargeValue("");
  };

  // Open delete confirmation
  const handleDeleteClick = (index) => {
    setPendingDeleteIndex(index);
    setDeleteConfirmOpen(true);
  };

  // Confirm delete
  const handleConfirmDelete = () => {
    const updatedSectionDetails = [...sectionDetails];
    updatedSectionDetails.splice(pendingDeleteIndex, 1);
    pushSectionHistory(updatedSectionDetails);
    setDeleteConfirmOpen(false);
    setPendingDeleteIndex(null);
  };

  const handleCancel = () => {
    setConfirmOpen(true);
  };

  const handleSave = async () => {
    try {
      const Url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${Url}/CreateClass?Id=${classId}`;
      const token = sessionStorage.getItem("token");

      const sectionsData = sectionDetails.map((section) => ({
        sectionId: section.sectionId,
        seactCapacity: section.seatCapacity,
        teacherId: section.inchargeId || section.teacherId,
      }));

      const classChargeData = chargeDetails
        .filter((charge) => charge.checked)
        .map((charge) => ({
          charge: charge.chargeAmount || 0,
          chargeId: charge.chargeId,
        }));

      const requestBody = {
        className,
        sequenceNo: sequenceNo || 0,
        classTypeId: selectedValue,
        classMinAge: minAge,
        classMaxAge: maxAge,
        noOf_BrackLeacture: breakAfterLectureNo || 0,
        no_OfBrack: 1,
        maxLecture,
        resultType,
        sectionsData,
        classChargeData,
      };

      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: { "Content-Type": "application/json", Authorization: token },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) throw new Error(`Error posting data: ${response.status}`);

      const responseData = await response.json();

      if (responseData.status === "Failed!" && responseData.msg === "Class Name already exist!") {
        setSnackbarMessage(responseData.msg);
        setOpenSnackbar(true);
        setSnackbarSeverity("error");
      } else {
        setShowSuccessModal(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleDialogClose = () => {
    setOpenSuccessDialog(false);
    navigate(-1);
  };

  useEffect(() => {
    const loadChargesInOrder = async () => {
      await fetchddlcharge();
      await fetchClassChargeDetails();
    };
    fetchClassType();
    fetchTeacher();
    fetchSection();
    fetchClassSectionDetails();
    loadChargesInOrder();
    Authorizer();
  }, []);

  const handleMaxLectureChange = (event) => setMaxLectureAllowed(event.target.value);
  const handleNoBreakCheckboxChange = (event) => setNoBreakCheckbox(event.target.checked);
  const handleBreakAfterLectureChange = (event) => setBreakAfterLectureNo(event.target.value);
  const handleMinAgeChange = (event) => setMinAge(event.target.value);
  const handleMaxAgeChange = (event) => setMaxAge(event.target.value);

  return (
    <Container>
      <Box
        sx={{
          backgroundColor: '#0B1F40',
          padding: '12px 24px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit Class
        </Typography>
      </Box>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
        <Grid container spacing={4} sx={{ marginTop: 1 }}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="class-label">Class Type</InputLabel>
              <Select
                labelId="class-label"
                id="class"
                label="Class Type"
                value={selectedValue}
                onChange={(e) => setSelectedValue(e.target.value)}
              >
                <MenuItem value="">Select</MenuItem>
                {classType.map((item) => (
                  <MenuItem key={item.classTypeId} value={item.classTypeId}>
                    {item.classType}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              id="sequence"
              label="Sequence No."
              variant="outlined"
              fullWidth
              value={sequenceNo}
              onChange={(e) => setSequenceNo(e.target.value)}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ marginTop: 1 }}>
          <Grid item xs={12} md={6}>
            <TextField
              id="className"
              label="Class Name"
              variant="outlined"
              fullWidth
              value={className}
              onChange={(e) => setClassName(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth>
              <InputLabel id="resultType-label">Result Type</InputLabel>
              <Select
                labelId="resultType-label"
                id="resultType"
                label="Result Type"
                value={resultType}
                onChange={(e) => setResultType(e.target.value)}
              >
                <MenuItem value="">--Select--</MenuItem>
                <MenuItem value="1">Grading Wise</MenuItem>
                <MenuItem value="2">Division Wise</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={3} sx={{ marginTop: -1 }}>
          <Grid item xs={12} md={6}>
            <Box component={Paper} sx={{ p: 2 }}>
              <Typography variant="h6" sx={{ mb: 4 }}>
                <strong>Lecture Details</strong>
              </Typography>
              <TextField
                id="max-lecture-allowed"
                label="Max Lecture Allowed"
                variant="outlined"
                fullWidth
                value={maxLecture}
                onChange={handleMaxLectureChange}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    id="no-break-checkbox"
                    checked={noBreakCheckbox}
                    onChange={handleNoBreakCheckboxChange}
                  />
                }
                label="No break for the Class"
              />
              <TextField
                id="break-after-lecture-no"
                label="Break after Lecture No."
                variant="outlined"
                fullWidth
                value={breakAfterLectureNo}
                onChange={handleBreakAfterLectureChange}
              />
              <div style={{ display: "flex", marginTop: 10 }}>
                <TextField
                  id="min-age"
                  label="Min Age"
                  variant="outlined"
                  sx={{ mr: 1 }}
                  value={minAge}
                  onChange={handleMinAgeChange}
                />
                <TextField
                  id="max-age"
                  label="Max Age"
                  variant="outlined"
                  value={maxAge}
                  onChange={handleMaxAgeChange}
                />
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box component={Paper} sx={{ p: 2 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                <strong>Add Section Details</strong>
              </Typography>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel id="section-label">Section</InputLabel>
                <Select
                  labelId="section-label"
                  id="section"
                  label="Section"
                  value={sectionNameValue}
                  onChange={(e) => setSectionNameValue(e.target.value)}
                >
                  <MenuItem value="">Select</MenuItem>
                  {sectionData.map((item) => (
                    <MenuItem key={item.sectionId} value={item.sectionId}>
                      {item.sectionName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                id="seat-capacity"
                label="Seat Capacity"
                variant="outlined"
                fullWidth
                value={seatCapacityValue}
                onChange={(e) => setSeatCapacityValue(e.target.value)}
                sx={{ mb: 2 }}
              />
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel id="incharge-label">Incharge</InputLabel>
                <Select
                  labelId="incharge-label"
                  id="incharge"
                  label="Incharge"
                  value={inchargeValue}
                  onChange={(e) => setInchargeValue(e.target.value)}
                >
                  <MenuItem value="">Select</MenuItem>
                  {teacherData.map((item) => (
                    <MenuItem key={item.employeeId} value={item.employeeId}>
                      {item.employeeName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button onClick={handleAddSectionDetails} startIcon={<Add />} variant="contained">
                Add Section
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>

      <Grid container spacing={3} sx={{ marginTop: 3 }}>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: '#0B1F40',
              padding: '12px 24px',
              boxShadow: 3,
              borderRadius: '4px 4px 0 0',
              margin: '2px auto',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Class Charges
            </Typography>
          </Box>
          <Paper sx={{ p: 2 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <Checkbox
                        checked={selectAllChecked}
                        onChange={handleToggleAll}
                        indeterminate={
                          chargeDetails.some((item) => item.checked) && !selectAllChecked
                        }
                      />
                    </TableCell>
                    <TableCell>Charge Name</TableCell>
                    <TableCell>Charge Type</TableCell>
                    <TableCell>Charge Amount</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {chargeDetails.map((item) => (
                    <TableRow key={item.chargeId}>
                      <TableCell>
                        <Checkbox
                          checked={item.checked || false}
                          onChange={() => handleIndividualCheckboxChange(item.chargeId)}
                        />
                      </TableCell>
                      <TableCell>{item.chargeName}</TableCell>
                      <TableCell>{item.chargeType}</TableCell>
                      <TableCell>
                        <TextField
                          variant="outlined"
                          type="number"
                          value={item.chargeAmount}
                          onChange={(event) => handleChargeAmountChange(event, item.chargeId)}
                          size="small"
                          sx={{ width: "120px" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div style={{ textAlign: "right", marginTop: '7px' }}>
              <Button onClick={handleSave} variant="contained" color="primary">
                UPDATE
              </Button>
              <Button
                onClick={handleCancel}
                variant="contained"
                color="error"
                sx={{ ml: 1 }}
              >
                Cancel
              </Button>
            </div>
          </Paper>
        </Grid>

        <Dialog open={openSuccessDialog} onClose={handleDialogClose}>
          <DialogTitle>Success</DialogTitle>
          <DialogContent>
            <Typography>Data saved successfully!</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} variant="contained" color="primary">OK</Button>
          </DialogActions>
        </Dialog>

        {/* Section Details List with Undo/Redo in header */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: '#0B1F40',
              padding: '8px 24px',
              boxShadow: 3,
              borderRadius: '4px 4px 0 0',
              margin: '2px auto',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Section Details List
            </Typography>
            <Box>
              <Tooltip title="Undo" arrow>
                <span>
                  <IconButton
                    onClick={handleUndo}
                    disabled={sectionHistoryIndex === 0}
                    size="small"
                    sx={{ color: '#fff', '&.Mui-disabled': { color: 'rgba(255,255,255,0.3)' } }}
                  >
                    <Undo />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Redo" arrow>
                <span>
                  <IconButton
                    onClick={handleRedo}
                    disabled={sectionHistoryIndex === sectionHistory.length - 1}
                    size="small"
                    sx={{ color: '#fff', '&.Mui-disabled': { color: 'rgba(255,255,255,0.3)' } }}
                  >
                    <Redo />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
          </Box>

          <Paper sx={{ p: 2 }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Section Name</TableCell>
                    <TableCell>Seat Capacity</TableCell>
                    <TableCell>Incharge</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sectionDetails.map((section, index) => (
                    <TableRow key={index}>
                      <TableCell>{section.sectionName || section.section}</TableCell>
                      <TableCell>{section.seatCapacity}</TableCell>
                      <TableCell>{section.incharge || section.teacherName}</TableCell>
                      <TableCell>
                       <Tooltip title={!canDelete && "You are not Authorized to Delete"} arrow>
  <span>
    <Button
      onClick={() => handleDeleteClick(index)}
      startIcon={<Delete />}
      color="error"
      size="small"
      disabled={!canDelete}
    >
      Delete
    </Button>
  </span>
</Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>
      </Grid>

      {/* Success Modal */}
      <Modal open={showSuccessModal} onClose={() => setShowSuccessModal(false)}>
        <Box
          sx={{
            position: 'absolute', top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography variant="h6" sx={{ color: '#fff' }}>Class Updated ✅</Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography sx={{ mb: 2 }}>The Class has been Updated successfully.</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={() => { setShowSuccessModal(false); navigate(-1); }} variant="contained" color="primary">
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Cancel Confirmation Modal */}
      <Modal open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <Box
          sx={{
            position: 'absolute', top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 350, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography variant="h6" sx={{ color: '#fff' }}>Confirm Cancel</Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography sx={{ mb: 2 }}>Are you sure you want to cancel? Unsaved changes will be lost.</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
              <Button variant="outlined" onClick={() => setConfirmOpen(false)}>No</Button>
              <Button variant="contained" color="error" onClick={() => navigate(-1)}>Yes, Cancel</Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal open={deleteConfirmOpen} onClose={() => setDeleteConfirmOpen(false)}>
        <Box
          sx={{
            position: 'absolute', top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 350, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#8B0000', padding: '12px 16px' }}>
            <Typography variant="h6" sx={{ color: '#fff' }}>Confirm Delete</Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography sx={{ mb: 2 }}>Are you sure you want to delete this section?</Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
              <Button variant="outlined" onClick={() => setDeleteConfirmOpen(false)}>No</Button>
              <Button variant="contained" color="error" onClick={handleConfirmDelete}>Yes, Delete</Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default EditClass;